import { useState } from "react";
import { Loader2, Camera } from "lucide-react";
import { fotoApi, fotoError, FOTO_TOKEN_KEY, FOTO_DEVICE_KEY } from "./fotoApi";
import { PasswordInput } from "../../components/PasswordInput";
import { FotoInstallButton } from "./FotoPwa";

const field = "w-full h-14 rounded-xl border border-slate-300 bg-white px-4 text-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-amber-500";

export const FotoLogin = ({ onLogged }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState(null);
  const [code, setCode] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const done = (data) => {
    localStorage.setItem(FOTO_TOKEN_KEY, data.token);
    if (data.device_id) localStorage.setItem(FOTO_DEVICE_KEY, data.device_id);
    onLogged(data.user);
  };
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      if (!otp) {
        const { data } = await fotoApi.post("/login", { email, password, device_id: localStorage.getItem(FOTO_DEVICE_KEY) || undefined });
        if (data.otp_required) setOtp(data); else done(data);
      } else {
        const { data } = await fotoApi.post("/otp/verify", { challenge_id: otp.challenge_id, code, remember });
        done(data);
      }
    } catch (ex) { setErr(fotoError(ex)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="foto-login-form">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-12 w-12 rounded-xl bg-amber-500 flex items-center justify-center"><Camera className="h-6 w-6 text-slate-900" /></div>
        <div><h1 className="text-2xl font-bold text-slate-900">Foto pratica</h1><p className="text-sm text-slate-500">Accedi con le credenziali del gestionale</p></div>
      </div>
      {!otp ? (
        <>
          <input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required className={field} data-testid="foto-login-email" />
          <div className="relative"><PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required className={`${field} !h-14 !text-lg`} data-testid="foto-login-password" /></div>
        </>
      ) : (
        <>
          <p className="text-sm text-slate-600" data-testid="foto-otp-info">Abbiamo inviato un codice a {otp.email}</p>
          <input inputMode="numeric" autoComplete="one-time-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Codice a 6 cifre" required className={`${field} tracking-[0.4em] text-center`} data-testid="foto-otp-code" />
          <label className="flex items-center gap-2 text-sm text-slate-600"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="h-5 w-5" data-testid="foto-otp-remember" /> Ricordami su questo telefono</label>
        </>
      )}
      {err && <p className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700" role="alert" data-testid="foto-login-error">{err}</p>}
      <button type="submit" disabled={busy} data-testid="foto-login-submit"
        className="w-full h-14 rounded-xl bg-amber-500 hover:bg-amber-600 active:scale-[0.99] text-lg font-bold text-slate-900 transition-transform disabled:opacity-60 flex items-center justify-center">
        {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : otp ? "Verifica codice" : "Accedi"}
      </button>
      <FotoInstallButton />
    </form>
  );
};
